import './ScrollableCalendar.css';
export default {
    "scrollableCalendar": "ScrollableCalendar_scrollableCalendar__18oe8",
    "months": "ScrollableCalendar_months__18oe8",
    "scrollableList": "ScrollableCalendar_scrollableList__18oe8"
};
